<h1 class="cab-title">{{ t(titleKey, titleFallback) }}</h1>
